export default {
  form: {
    preparation_time: {
      label: 'Benutzerdefinierte Zeit (Minuten) eingeben:',
      placeholder: 'Minuten eingeben',
    },
  },
  buttons: {
    custom: 'Kundenspezifisch',
  },
  feedback: {
    preparation_time_required: 'Die Zubereitungszeit muss mehr als 0 Minuten betragen.',
    min_preparation_time: 'Mindestens {{minutes}} Minuten Vorbereitungszeit für externe Lieferung',
    max_preparation_time: 'Maximal {{minutes}} Minuten als Vorbereitungszeit',
  },
};
